import {
  formatLink,
  getMediumLink, getVal,
  hideDialog,
  isnull,
  loadGreetHistory, loadViewedCommonHotListHistory,
  localGet,
  saveGreetHistory,
  showDialog, sleep,
  Toast
} from "../tools";
import momApi from '../../api/moment-api'
import TipsUtils, {ResultCode} from "../TipsUtils";
import EventBusConstant from "../../push/const/EventBusConstant";
import global from "../../config/global";
import router from '../../router'
import accAPi from "../../api/account-api";
import IMManager from "../../im/IMManager";
import Tips from "../Tips";
import {follow} from "../../api/home-api";
import MonitorKeyboard from "../keyboard";
import BlockedUserUtils from "../BlackUtils";
import StatisticsHelper from "../StatisticsUtils";
import BlackUtils from "../BlackUtils";

export const MomType = {
  following: 'momentFollowing',
  hot: 'momentHot',
  new: 'momentNew',
  mineCom: "momentComment",
  com: "comment",
  cDetail: 'commentDetail',
  host: 'host',
}

export default class MomentHelper {
  static curPageTag

  static inPlayWidget;
  static inSayHi;

  constructor(tag, page) {
    this.tag = tag
    this.pageVueObj = page
    this._m = new Date().getTime()
    this.formatter = new Formatter()
    this.loader = new Loader(tag, page)
    this.clicker = new Clicker(this, page)
    this.keyboard = new MonitorKeyboard();
    this.inComment = false
    let helper = this
    this.keyboard.onShow(() => {
      helper.recoveryScrollTop()
      if (helper.pageVueObj.inInputComment != 'undefined') helper.pageVueObj.inInputComment = true
      if (helper.pageVueObj.commentReplyTarget) {
        page.$refs.fastReply.focus()
        // $('textarea.input').focus()
      }
    })
    this.keyboard.onHidden(() => {
      helper.recoveryScrollTop()
      if (helper.pageVueObj.inInputComment) helper.pageVueObj.inInputComment = false
    })
  }


  /**
   * 动态点赞或取消点赞
   * @param moment
   */
  likeOrCancelMoment(moment) {
    if (isnull(moment) || isnull(moment.momentId))
      return
    if (moment.isLiked) {
      //doCancelLike
      moment.isLiked = false
      moment.likes--
      momApi.doCancelLikeMoment(moment.momentId, () => {
      }, (code, msg, page) => {
        Toast.error(TipsUtils.getErrorTips(code), page)
        moment.isLiked = true
        moment.likes++
      }, this.pageVueObj)
    } else {
      //doLike
      moment.isLiked = true
      moment.likes++
      momApi.doLikeMoment(moment.momentId, () => {

      }, (code, msg, page) => {
        Toast.error(TipsUtils.getErrorTips(code), page)
        moment.isLiked = false
        moment.likes--
      }, this.pageVueObj)
    }
  }

  /**
   * 动态打招呼
   * @param moment
   */
  sayHi(moment) {
    if (BlockedUserUtils.hasBeenBlocked(moment.accountId)) {
      Toast.error(Tips.e_block_in_chat, this.pageVueObj)
      return;
    }
    if (moment.isGreeted)
      return
    let showGreetAgain = !localGet(global.getUserDisplay() + global.key.GREET_TIPS_HIDE)
    if (global.isSVip() || !showGreetAgain) {
      MomentHelper.toSayHI(moment.accountId, () => {
        this.saveAndRefreshSayHi(moment)
      }, () => {
        this.recoveryAndRefreshSayHi(moment)
      }, this.pageVueObj)
    } else {
      this.pageVueObj.$EventBus.$emit(EventBusConstant.EVENT_SHOW_MOMENT_SAYHI, moment.accountId, () => {
        this.saveAndRefreshSayHi(moment)
      }, () => {
        this.recoveryAndRefreshSayHi(moment)
      })
    }

  }

  static toSayHI(accountId, doAfterSucceedCallback, doAfterFailedCallback, vueObj) {
    if (isnull(accountId)) {
      console.log('no momentId for sayhi')
      return
    }
    if (!global.isSVip() && !global.checkCoinsEnough(2)) {
      Toast.error('Coins not enough', vueObj)
      return
    }
    showDialog(vueObj)
    let target = vueObj
    doAfterSucceedCallback && doAfterSucceedCallback()
    accAPi.getAnchorInfo(accountId, (data, page) => {
      if (getVal(IMManager.curTargetPerson, 'accountId', '') != accountId) {
        IMManager.crtConvCallback = (code, msg, page) => {
          if (code != 0) {
            Toast.error(msg, target)
            hideDialog(target)
            doAfterFailedCallback && doAfterFailedCallback()
            return
          }
          IMManager.sendTextMessage(Tips.tips_moment_hi, false, (code) => {
            hideDialog(target)
            if (code != 0)
              doAfterFailedCallback && doAfterFailedCallback()
            else
              Toast.info(Tips.tips_greet_successfully, target)
          })
        }
        IMManager.createConvByP(data, vueObj)
      } else {
        IMManager.sendTextMessage(Tips.tips_moment_hi, false, (code) => {
          hideDialog(target)
          if (code != 0)
            doAfterFailedCallback && doAfterFailedCallback()
          else
            Toast.info(Tips.tips_greet_successfully, target)
        })
      }
    }, (code, msg, page) => {
      doAfterFailedCallback && doAfterFailedCallback()
    }, vueObj)
  }


  /**
   * 刷新数据
   * @param moment
   */
  saveAndRefreshSayHi(moment) {
    this.pageVueObj.greetHistory.push(moment.momentId)
    moment.isGreeted = true
    saveGreetHistory(this.pageVueObj.greetHistory)
  }

  recoveryAndRefreshSayHi(moment) {
    let index = this.pageVueObj.greetHistory.indexOf(moment.momentId)
    if (index > -1 && index < this.pageVueObj.greetHistory.length) {
      this.pageVueObj.greetHistory.splice(index, 1)
      saveGreetHistory(this.pageVueObj.greetHistory)
    }
    moment.isGreeted = false
  }

  refreshUnread() {
    momApi.loadMineCommentUnread((data, page) => {
      page.$EventBus.$emit(EventBusConstant.EVENT_REFRESH_MINE_MOM_COUNT, data)
    }, null, this.pageVueObj)
  }

  playVideo(moment, from = '') {
    this.pageVueObj.$EventBus.$emit(EventBusConstant.EVENT_SHOW_VIDEO, moment.video, this.formatter.wrapCover(moment.videoCover))
    // if (MomentHelper.inPlayWidget) {
    //   MomentHelper.inPlayWidget.pause()
    //   MomentHelper.inPlayWidget = null
    // }
    // let helper = this
    // let id = moment.momentId
    // let playBtn = null;
    // if (from == 'anchor') {
    //   MomentHelper.inPlayWidget = document.getElementById('vp-v-' + id)
    //   playBtn = document.getElementById('vp-p-' + id)
    // } else {
    //   MomentHelper.inPlayWidget = document.getElementById('mom-v-' + id)
    //   playBtn = document.getElementById('mom-p-' + id)
    // }
    // if (!isnull(playBtn)) playBtn.style.display = 'none'
    // MomentHelper.inPlayWidget.play()
    // AppSDK.screenOut(false)
    // MomentHelper.inPlayWidget.onpause = () => {
    //   MomentHelper.stopVideo(moment, helper, from)
    // }
    // MomentHelper.inPlayWidget.onended = () => {
    //   MomentHelper.stopVideo(moment, helper, from)
    // }
    // MomentHelper.inPlayWidget.addEventListener('pause', function () {
    //   MomentHelper.stopVideo(moment, helper, from)
    // })
    // MomentHelper.handleFullscreen(MomentHelper.inPlayWidget, true)

  }

  static stopVideo(moment, helper, from = '') {
    let widget = null;
    let playBtn = '';
    let momentId = moment.momentId
    if (from == 'anchor') {
      widget = document.getElementById('vp-v-' + momentId)
      playBtn = document.getElementById('vp-p-' + momentId)
    } else {
      widget = document.getElementById('mom-v-' + momentId)
      playBtn = document.getElementById('mom-p-' + momentId)
    }
    playBtn.style.display = 'block'
    widget.pause()
    this.handleFullscreen(null, false)
  }

  static handleFullscreen(widget, fullscreen) {
    if (fullscreen) {
      if (widget.requestFullscreen)
        widget.requestFullscreen()
      else if (widget.webkitRequestFullScreen)
        widget.webkitRequestFullScreen()
      else if (widget.mozRequestFullScreen)
        widget.mozRequestFullScreen()
      else if (widget.msRequestFullscreen)
        widget.msRequestFullscreen()
    } else {
      if (document.exitFullscreen)
        document.exitFullscreen()
      else if (document.webkitCancelFullScreen)
        document.webkitCancelFullScreen()
      else if (document.mozCancelFullScreen)
        document.mozCancelFullScreen()
      else if (document.msExitFullscreen)
        document.msExitFullscreen()
    }
  }

  clickImg(imgList, startIndex) {
    this.pageVueObj.$EventBus.$emit(EventBusConstant.EVENT_SHOW_PHOTO_GALLERY, imgList, startIndex)
  }

  doReportMoment(momentId) {
    this.pageVueObj.$EventBus.$emit(EventBusConstant.EVENT_MOMENT_REPORT_DEL, 1, momentId)
  }

  sendComment(sucCallback = null) {
    let content = this.pageVueObj.mineCommentWords.trim()
    let commentContent = BlockedUserUtils.filterSensitiveDM(content)
    commentContent = commentContent.replace(/&/g, '***')
    if (isnull(commentContent)) {
      Toast.error('Comments not be empty', this.pageVueObj)
      this.pageVueObj.mineCommentWords = ''
      return
    }
    let type = 1;
    let objectId = '';
    let helper = this
    if (!this.inComment) {
      let commentHandler = {
        suc: (data, page) => {
          page.moment && page.moment.commments++

          page.mineCommentWords = ''
          page.commentReplyTarget = ''
          helper.inComment = false
          sucCallback && sucCallback(type, objectId, data, page)
        },
        fail: (code, msg, page) => {
          helper.inComment = false
          Toast.error(TipsUtils.getErrorTips(code), page)
        }
      }

      if (!isnull(this.pageVueObj.commentReplyTarget)) {
        type = 2;
        objectId = this.pageVueObj.commentReplyTarget.commentId;
        momApi.doReplyComment(objectId, commentContent, commentHandler.suc, commentHandler.fail, this.pageVueObj)
      } else {
        objectId = this.pageVueObj.momentId;
        momApi.doCommentMoment(objectId, commentContent, commentHandler.suc, commentHandler.fail, this.pageVueObj)
      }
      this.inComment = true
    }
  }

  doFollowAction() {
    let isFollowed = this.pageVueObj.moment.isFollowed
    let accountId = this.pageVueObj.moment.accountId
    if (isFollowed) {
      if (!IMManager.hasClient(this)) {
        Toast.error('Please  check your network to continue.', this)
        return
      }
      showDialog(this.pageVueObj)
      try {
        accAPi.getAnchorInfo(accountId, (data, page) => {
          router.togo({
            name: 'ChatRoom',
            params: {
              acc: accountId || '',
              user: data || ''
            }
          })
        }, (code, msg, page) => {
          Toast.error(TipsUtils.getErrorTips(code), page)
        }, this.pageVueObj, false, false)
      } catch (e) {
        hideDialog(this.pageVueObj)
      }


    } else {
      follow(accountId, function (data, target) {
        target.moment.isFollowed = true
        Toast.info('Followed successfully', target)
      }, function (code, msg, page) {
        Toast.error('Followed failed', page)
      }, this.pageVueObj)
    }
  }

  checkData(data) {
    return isnull(data)
  }

  showCommentReplay(comment) {
    this.recordScrollTop()
    if ([MomType.cDetail, MomType.mineCom].indexOf(this.tag) != -1) {
      this.pageVueObj.inInputComment = true
      let helper = this
      if (helper.pageVueObj.commentReplyTarget == comment) {
        this.pageVueObj.$nextTick(() => {
          setTimeout(() => {
            helper.pageVueObj.$refs.fastReply.focus()
            // $('textarea.input').focus()
          }, 300)
        })
      }
    } else {
      if (this.pageVueObj.commentReplyTarget == comment) {
        this.pageVueObj.$refs.fastReply.focus()
        // $('textarea.input').focus()
      }
    }
    this.pageVueObj.commentReplyTarget = comment

  }

  recordScrollTop() {
    this.pageVueObj.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  }

  recoveryScrollTop() {
    if (document.documentElement.scrollTop) {
      document.documentElement.scrollTop = this.pageVueObj.scrollTop
    }
    if (document.body.scrollTop) {
      document.body.scrollTop = this.pageVueObj.scrollTop
    }
  }

  doSkipAction(event) {
    if (event.target.nodeName.toLowerCase() === 'span') {
      let url = event.target.getAttribute('t')
      this.skip(url)
      event.stopPropagation()
    }
  }

  skip(url) {
    if (isnull(url))
      return
    this.pageVueObj.$EventBus.$emit(EventBusConstant.EVENT_SHOW_HC, 2, formatLink(url))
  }

  removeCommentData(datas, target) {
    if (isnull(datas) || isnull(target))
      return
    for (let i in datas) {
      let comment = datas[i];
      if (comment.commentId == target.commentId) {
        datas.splice(i, 1)
        return;
      }
      if (!isnull(comment.expandComments)) {
        for (let innerI in comment.expandComments) {
          if (comment.expandComments[innerI].commentId == target.commentId) {
            comment.expandComments.splice(innerI, 1)
            return;
          }
        }
      }
    }
  }

  expandComments(comment) {
    if (comment.expandCount < comment.expandComments.length) {
      let targetCount = Math.min(comment.expandComments.length, comment.expandCount + 5)
      comment.expandCount = targetCount
    }
  }

  toMomentDetail(moment) {
    router.togo({
      name: 'MomentDetail',
      params: {
        id: moment.momentId
      }
    })
    if (this.tag == MomType.following) {
      momApi.viewFollowingMoment(null, null, this.pageVueObj)
    }
  }

  toCommentDetail(commentId) {
    router.togo({
      name: 'CommentDetail',
      params: {
        id: commentId
      }
    })
  }

  toAnchorInfo(accId, roleType) {
    if (roleType != 2)
      return;
    if (isnull(accId)) {
      Toast.error('server busy', this.pageVueObj)
      return
    }
    StatisticsHelper.user_action()
    router.togo({
      name: 'AnchorInfoDetail',
      params: {
        acc: accId || '',
      }
    })
  }

}

/**
 * 格式化显示
 */
class Formatter {
  linkReg = new RegExp("((http[s]{0,1}|ftp)://[a-zA-Z0-9\\.\\-]+\\.([a-zA-Z]{2,4})(:\\d+)?(/[a-zA-Z0-9\\.\\-~!@#$%^&*+?:_/=<>]*)?)|(www.[a-zA-Z0-9\\.\\-]+\\.([a-zA-Z]{2,4})(:\\d+)?(/[a-zA-Z0-9\\.\\-~!@#$%^&*+?:_/=<>]*)?)", 'g')
  protocolReg = new RegExp("(http[s]{0,1}|ftp)://")

  constructor() {
    // this.linkReg=new RegExp("((http[s]{0,1}|ftp)://[a-zA-Z0-9\\\\.\\\\-]+\\\\.([a-zA-Z]{2,4})(:\\\\d+)?(/[a-zA-Z0-9\\\\.\\\\-~!@#$%^&*+?:_/=<>]*)?)|(www.[a-zA-Z0-9\\\\.\\\\-]+\\\\.([a-zA-Z]{2,4})(:\\\\d+)?(/[a-zA-Z0-9\\\\.\\\\-~!@#$%^&*+?:_/=<>]*)?)")
  }

  wrapLikeNums(nums) {
    if (nums < 999)
      return nums
    return (nums / 1000).toFixed(1) + 'K'
  }

  wrapMomentTime(time) {
    return new Date(parseInt(time) * 1000).toDiffString()
  }

  wrapImgType(tw, th) {
    return tw / th >= 1 ? 'landscape' : 'portrait'
  }

  wrapTypeTag(tag) {
    if (tag == 1) {
      return 'new'
    }
    if (tag == 2)
      return 'hot'
    if (tag == 3)
      return 'official'
    return ''
  }

  wrapStatus(moment) {
    if (!isnull(moment.multipleLive) && moment.multipleLive.roomId != 0)
      return 'living'
    if ([0, 1].indexOf(moment.lineStatus) != -1)
      return 'idle'
    return ''
  }

  wrapCover(src) {
    return getMediumLink(src)
  }

  wrapCommentName(comment, name) {
    if (!isnull(comment.receiverNickname)) {
      if (name.length > 18) {
        return name.substr(0, 18) + '...'
      }
    }
    return name
  }

  wrapCommentContent(comment) {
    if (comment.senderAccountId == global.getUserId())
      return comment.content
    return BlockedUserUtils.filterSensitiveDM(comment.content, '')
  }

  wrapMomentContent(moment) {
    let content = moment.content;
    if (!isnull(content)){
      let matches = content.match(this.linkReg);
      for (let i in matches) {
        let target = matches[i]
        content = content.replace(new RegExp(target, 'g'), '<span class="link" t="' + target + '" style="color: blue">[Link]</span>')
      }
    }
    return BlackUtils.filterSensitiveDM(content)
  }


}

/**
 * 数据加载
 */
class Loader {

  constructor(tag, pageV) {
    this.tag = tag
    this.pageV = pageV
    this.curCount = 0
    this.isLoading = false
    this.timer = null
    this.type = 1
    this.canLoad = true
  }

  getListDataKey() {
    if (this.tag == MomType.hot)
      return 'loadHoTMomentList'
    if (this.tag == MomType.new)
      return 'loadNewMomentList'
    if (this.tag == MomType.mineCom)
      return 'loadMineCommentList'
    if (this.tag == MomType.com)
      return 'loadMomentCommentList'
    if (this.tag == MomType.host)
      return 'loadAnchorMomentList'
    return 'loadFollowingMomentList'
  }

  getDetailDataKey() {
    if (this.tag == MomType.com)
      return 'loadMomentDetail'
    return 'loadCommentDetail'
  }

  loadDataList(id = null, showLoading = true) {
    if (!isnull(MomentHelper.curPageTag) && MomentHelper.curPageTag != this.tag)
      return;
    let key = this.getListDataKey()
    if (isnull(key))
      return
    let loader = this
    let dataHandler = {
      suc: function (data, page) {
        page.$EventBus.$emit(EventBusConstant.EVENT_HIDE_HOLDER_IN_HOME)
        let length = isnull(data) ? 0 : data.length
        let filterIndex = []
        if ([MomType.following, MomType.hot, MomType.new, MomType.host].indexOf(loader.tag) != -1) {
          page.greetHistory = loadGreetHistory()
          if (MomType.hot == loader.tag)
            page.viewedHotHistory = loadViewedCommonHotListHistory()
          for (let i = 0; i < length; i++) {
            let tmp = data[i];
            tmp.isGreeted = page.greetHistory.indexOf(tmp.momentId) > -1
            if (MomType.hot == loader.tag && page.viewedHotHistory.indexOf(tmp.momentId) != -1) {
              filterIndex.push(i)
            }
          }
        }
        if ([MomType.com].indexOf(loader.tag) != -1) {
          for (let i = 0; i < length; i++) {
            let tmp = data[i];
            tmp.expandCount = 2
          }
        }
        loader.isLoading = false
        loader.curCount += length
        if (loader.type == 1) {
          page.dataList = Array()
        }
        if (length > 0) {
          if (MomType.hot == loader.tag && !isnull(page.viewedHotHistory))
            for (let i = 0; i < length; i++) {
              let tmp = data[i];
              if (page.viewedHotHistory.indexOf(tmp.momentId) == -1) {
                page.dataList.push(tmp)
              }
            }
          else
            page.dataList.push(...data)
        }
      },
      fail: function (code, msg, page) {
        loader.isLoading = false
        Toast.error(TipsUtils.getErrorTips(code), page)
      }
    }
    if (!loader.isLoading) {
      loader.isLoading = true
      if (isnull(id))
        momApi[key](this.curCount, dataHandler.suc, dataHandler.fail, this.pageV, showLoading, showLoading)
      else {
        momApi[key](id, this.curCount, dataHandler.suc, dataHandler.fail, this.pageV, showLoading, showLoading)
      }
    }

  }

  loadDetail(id) {
    let key = this.getDetailDataKey()
    if (isnull(key))
      return
    let loader = this
    momApi[key](id, (data, page) => {
      if ([MomType.com] == loader.tag) {
        page.greetHistory = loadGreetHistory()
        data.isGreeted = page.greetHistory.indexOf(data.momentId) > -1
        if (isnull(page.moment)) {
          momApi.viewMoment(id, null, null, page)
        }
        page.moment = data
      }
      if (MomType.cDetail == loader.tag)
        page.comment = data;
    }, (code, msg, page) => {
      Toast.error(TipsUtils.getErrorTips(code), page)
    }, this.pageV)
  }

  refresh(id = null, showLoading = true) {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    this.type = 1
    this.curCount = 0
    this.timer = setTimeout(() => {
      this.loadDataList(id)
    })
  }

  loadMore(id = null, showLoading = true) {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    this.type = 2
    this.timer = setTimeout(() => {
      this.loadDataList(id, showLoading)
    })
  }


}

/**
 * 单击/双击/判断
 */
class Clicker {
  constructor(helper, pageV) {
    this.pageV = pageV
    this.momentHelper = helper
    this.isLongClick = false
    this.isClick = false
    this.timeOutEvent = 0
  }

  goTouchMove(event) {
    if (event.target.getAttribute('class').indexOf('child-commend-more-action-panel') != -1) {
      event.stopPropagation()
      return
    }
    if (this) {
      this.isLongClick = false
      this.isClick = false
      clearTimeout(this.timeOutEvent)
      this.timeOutEvent = 0
    }
  }

  clearClickEvent() {
    if (this.timeOutEvent) {
      clearTimeout(this.timeOutEvent)
    }
  }

  goTouchStart(item, loader, event) {
    if (['child-commend-more-action-panel', 'avatar'].indexOf(event.target.getAttribute('class')) != -1) {
      event.stopPropagation()
      return
    }
    let clicker = this
    clicker.isLongClick = true
    clicker.isClick = true
    clicker.clearClickEvent()
    this.timeOutEvent = setTimeout(() => {
      if (item.senderAccountId == global.getUserId())
        clicker.pageV.$EventBus.$emit(EventBusConstant.EVENT_MOMENT_REPORT_DEL, 3, item.commentId, () => {
          if (loader.tag == MomType.cDetail) {
            if (item.commentId == loader.pageV.commentId) {
              loader.pageV.closePage()
            } else
              clicker.momentHelper.removeCommentData(loader.pageV.dataList, item)
          } else {
            if (loader.tag == MomType.com) {
              loader.loadDetail(item.momentId)
            }

            clicker.momentHelper.removeCommentData(loader.pageV.dataList, item)
          }
        })
      else
        clicker.pageV.$EventBus.$emit(EventBusConstant.EVENT_MOMENT_REPORT_DEL, 2, item.commentId)
      clicker.isClick = false
      clicker.isLongClick = false
    }, 600)
  }

  goTouchend(comment, loader, event) {
    if (event.target.getAttribute('class').indexOf('child-commend-more-action-panel') != -1) {
      event.stopPropagation()
      return
    }
    this.clearClickEvent()
    if (this.isClick) {
      this.momentHelper.showCommentReplay(comment)
      // $('.input-panel').focus()
      // loader.pageV.$nextTick(() => {
      //   setTimeout(() => {
      //     // $('input.input').focus()
      //     loader.pageV.$refs.commentInputRef.focus()
      //   }, 500)
      //   this.inputHolder = 'Reply ' + n.senderNickname
      // })
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/mom/MomentHelper.js